import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 14px;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 20px;
`